import config from '@/config.js'
import axios from '@/axios.js'

const type = {
  mutations: {
    checkMenu:'checkMenu'
  },
  getters: {
  },
  actions: {
  }
}

const state = {
  menuVal:false
}
const getters = {
}
const mutations = {
  [type.mutations.checkMenu] (state, v) {
    state.menuVal = v
  },
}
const actions = {
  [type.actions.getOpenRecordList] (context, v) {
    let suc = v.success
    v.success = function (data) {
      context.commit(type.mutations.mutate_getOpenRecordList, data)
      suc && suc(data)
    }
    return axios.post(config.API.Controller.gate.getOpenRecordList, v)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
export const TYPE = type
